import React, { FC, useMemo } from 'react';
import { AttributeDictionary } from '@hkm/components/TaskManagement/relations/domain/interfaces';

import {
  AcBadge,
  AcInfoBadge
} from '@ac/mobile-components/dist/components/badge';
import { AcFlex } from '@ac/mobile-components/dist/components/flex';

interface ComponentProps {
  attributesCodes: string[];
  attributes: AttributeDictionary[];
}

const Preferences: FC<ComponentProps> = (props: ComponentProps) => {
  const preferences = useMemo(
    () =>
      (props.attributesCodes || []).map(attributeCode => {
        const preferenceAttribute = (props.attributes || []).find(
          ({ code }) => code === attributeCode
        );

        const attributeColor = preferenceAttribute?.ref_attributeGroupId?.color;

        return {
          id: preferenceAttribute?.id,
          code: preferenceAttribute?.code,
          attributeColor
        };
      }),
    [props.attributesCodes, props.attributes]
  );

  return (
    <AcFlex wrapped={true}>
      {preferences.map((preference, index) =>
        preference.attributeColor ? (
          <AcBadge
            className="ac-spacing-right-sm ac-spacing-bottom-sm"
            key={preference.id}
            badgeText={preference.code!}
            backgroundColor={preference.attributeColor}
            testSelector={`task-preference-${index}`}
          />
        ) : (
          <AcInfoBadge
            className="ac-spacing-right-sm ac-spacing-bottom-sm"
            key={preference.id}
            badgeText={preference.code!}
            testSelector={`task-preference-${index}`}
          />
        )
      )}
    </AcFlex>
  );
};

export default Preferences;



// WEBPACK FOOTER //
// ./src/components/TaskManagement/TaskPreview/LinkedObject/shared/Preferences/Preferences.tsx